import { ShipmentDates } from '@diamond/shared/types';
import { useQuery } from '@tanstack/react-query';

import {
  getShipmentDates,
  ShipmentDateException,
} from '../queries/shipment-dates';
import { useAuthStore } from '../stores';

const MAX_TRANSIENT_RETRIES = 1;

export const useGetShipmentDates = (
  warehouse: string,
  handleRetry?: (failureCount: number, error: ShipmentDateException) => boolean
) => {
  const session = useAuthStore();
  const runQuery = typeof warehouse === 'string';

  return useQuery<ShipmentDates, ShipmentDateException>({
    queryKey: ['ShipmentDates', warehouse],
    queryFn: () => getShipmentDates(session.access_token, warehouse),
    enabled: runQuery,
    retry: (failureCount, error) => {
      if (error.isUpstreamFailure) return false;
      if (handleRetry) return handleRetry(failureCount, error);
      return failureCount < MAX_TRANSIENT_RETRIES;
    },
    retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 4000),
  });
};
